<template>
  <div
    v-if="filtering && keywordFilter && canEditKeywords"
    class="sub_heading_wrapper"
  >
    <div
      v-if="keywordFilter"
      class="clear_filter"
      @click="clearFilter('keywordFilter')"
    >
      Clear filter <span class="delete" />
    </div>
  </div>

  <div
    v-if="topics.length > 0"
    class="list_items"
  >
    <div
      v-for="(topic, index) in visibleTopics"
      :key="index"
      class="list_item"
      :class="{'active': topic[valueKey] === keywordFilter, [type]: true}"
    >
      <i
        v-if="addingSuggestion === topic[valueKey]"
        class="fas fa-spinner fa-spin"
      />

      <span
        class="keyword_value"
        :class="{'ml-1': addingSuggestion === topic[valueKey]}"
        @click="addingSuggestion === null && $emit('select-topic', topic)"
      >
        {{ topic[valueKey] }}
      </span>

      <template v-if="removable">
        <i
          v-if="removingKeyword === topic[valueKey]"
          class="fas fa-spinner fa-spin"
        />

        <button
          v-if="canEditKeywords && removingKeyword !== topic[valueKey]"
          :disabled="removingKeyword"
          class="delete"
          @click="removingKeyword === null && $emit('remove-topic', topic)"
        />
      </template>
    </div>
  </div>

  <template v-else>
    <slot name="topics-empty" />
  </template>

  <div
    v-if="topics.length > visibleTags"
    :class="'show '+(showAll ? 'less' : 'more')"
    @click="showAll = !showAll"
  >
    <i class="arrow_btn" />
    {{ showAll ? 'Show Less' : 'Show More' }}
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'TopicsList',
  props: {
    topics: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'keyword',
    },
    removable: {
      type: Boolean,
      default: true,
    },
    filtering: {
      type: Boolean,
      default: true,
    },
    valueKey: {
      type: String,
      default: 'keyword_topic',
    }
  },
  emits: ['remove-topic', 'select-topic'],
  data() {
    return {
      showAll: false,
      visibleTags: 3,
    }
  },
  computed: {
    ...mapGetters('keywordIdeas', [
      'keywordFilter',
      'removingKeyword',
      'addingSuggestion',
    ]),
    ...mapGetters('user', [
      'canEditKeywords',
    ]),
    visibleTopics() {
      if (this.showAll) {
        return this.topics;
      } else {
        return this.topics.slice(0, this.visibleTags);
      }
    },
  },
  methods: {
    ...mapActions('keywordIdeas', [
      'clearFilter',
    ]),
  }
}
</script>

<style scoped>
.keyword_value {
  text-transform: lowercase;
}
</style>
